/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { withRouter } from 'react-router'
import moment from 'moment'
import { push } from 'react-router-redux'
import queryString from 'query-string'
import styled from 'styled-components'
import { Colors, Table, TableCell, TableHeader, TableLoading, TextIcon, Pagination } from 'advenio-components'
import ProfileHeader from '../ProfileHeader'
import ClassroomActions from '../../Data/Redux/ClassroomRedux'

const Container = styled.div`
  padding: 8px;
`
const PaginationContainer = styled.div`
  padding: 8px;
`
const TableContainer = styled.div`
  margin: 8px;
`
const Description = styled.div`
  display: flex;
  flex-direction: column;
  p {
    margin: 0;
  }
`
const DeletedText = styled(TextIcon)`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: -8px;
`
const CellContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 60px;
  background-color: ${Colors.white300};
  white-space: ${props => props.large ? 'normal' : ''};
  text-align: center;

  img{
    max-height: 21px;
    cursor: pointer;

    &:nth-child(2){
      margin-left: 10px;
    }
  }
`

class Invoices extends Component {
  constructor(props) {
    super(props)
    this.state = {
      pageSelected: 1,
    }
  }

  componentDidMount() {
    this.props.getInvoices(this.props.studentId)
  }

  onClickPage = (page) => {
    this.setState({ pageSelected: page }, () => {
      const queryParams = {
        tab: 'invoices',
        page,
      }

      const { getInvoices, goTo } = this.props
      getInvoices(this.props.studentId, { page })
      goTo(`?${queryString.stringify(queryParams)}`)
    })
  }

  convertToXMLFile = (filename, stringXML) => {
    const element = document.createElement('a')
    element.setAttribute('href', `data:text/plain;charset=utf-8,${encodeURIComponent(stringXML)}`)
    element.setAttribute('download', filename)

    element.style.display = 'none'
    document.body.appendChild(element)

    element.click()

    document.body.removeChild(element)
  }

  render() {
    const { loading, invoices } = this.props
    const { pageSelected } = this.state

    return (
      <Container>
        <ProfileHeader
          header="Facturas"
          noSave
        />

        {!loading && invoices && invoices.data && <PaginationContainer>
          <Pagination
            totalElements={invoices && invoices.meta.total}
            elementsPerPage={invoices && invoices.meta.per_page}
            onPageClick={this.onClickPage}
            pageSelected={pageSelected}
          />
        </PaginationContainer>}
        <TableContainer>
          {loading ? (
            <TableLoading
              roundedCorners
              columns={[
                {
                  id: 1,
                  header: 'Fólio',
                  element: 'Text',
                  width: '100px',
                  center: true,
                },
                {
                  id: 2,
                  header: 'Descripción',
                  element: 'Text',
                },
                {
                  id: 3,
                  header: 'Fecha',
                  element: 'Text',
                },
                {
                  id: 4,
                  header: 'Total',
                  element: 'Text',
                },
                {
                  id: 5,
                  header: 'Estatus',
                  element: 'Text',
                },
                {
                  id: 6,
                  header: '',
                  element: 'Text',
                },
              ]}
              rows={5}
            />
          ) : (
            <Table
              roundedCorners
              data={invoices && invoices.data}
              columns={[
                {
                  id: 'invoice_number',
                  Header: () => <TableHeader title="Folio" blue center />,
                  maxWidth: 100,
                  Cell: ({ original: { invoice_number }, index }) => (
                    <TableCell index={index} center noEllipsis>
                      {invoice_number}
                    </TableCell>
                  ),
                },
                {
                  id: 'description',
                  sortable: false,
                  Header: () => <TableHeader title="Descripción" blue noEllipsis />,
                  Cell: ({ original: { tax_name, invoiceable }, index }) => (
                    <TableCell index={index} noEllipsis>
                      <Description>
                        <p><strong>Razón social:</strong> {tax_name}</p>
                        {invoiceable.name && <p><strong>Tutor: </strong> {invoiceable.name}</p>}
                        {invoiceable.student && <p><strong>Alumno: </strong> {invoiceable.student}</p>}
                      </Description>
                    </TableCell>
                  ),
                },
                {
                  id: 'fecha',
                  maxWidth: 100,
                  Header: () => <TableHeader title="Fecha" blue />,
                  Cell: ({ original: { created_at }, index }) => (
                    <TableCell index={index} noEllipsis>
                      {moment(created_at).format('DD MMM YY')}
                    </TableCell>
                  ),
                },
                {
                  id: 'total',
                  maxWidth: 140,
                  Header: () => <TableHeader title="Monto" blue />,
                  Cell: ({ original: { total_formatted }, index }) => (
                    <TableCell index={index} noEllipsis>
                      {total_formatted}
                    </TableCell>
                  ),
                },
                {
                  id: 'estatus',
                  maxWidth: 120,
                  Header: () => <TableHeader title="Estatus" blue />,
                  Cell: ({ original: { status }, index }) => (
                    <TableCell index={index} noEllipsis>
                      {status}
                    </TableCell>
                  ),
                },
                {
                  id: 'options',
                  maxWidth: 150,
                  sortable: false,
                  Header: () => <TableHeader title="" blue center />,
                  Cell: ({ original: { id, pdf_path, xml, cancelled_at } }) => {
                    let content = <span>Procesando Factura...</span>

                    if (pdf_path) {
                      if (xml) {
                        content =
                          (<div>
                            <img alt="" onClick={() => window.open(pdf_path)} src="/assets/pdf-file.svg" />
                            <img alt="" onClick={() => this.convertToXMLFile(`${id}.xml`, xml)} src="/assets/xml.svg" />
                          </div>)
                      } else {
                        content = <img alt="" onClick={() => window.open(pdf_path)} src="/assets/pdf-file.svg" />
                      }
                    } else if (cancelled_at) {
                      content = (
                        <div>
                          <DeletedText
                            label="Cancelada"
                            iconType="checkmark"
                            iconViewBox="0 1 18 18"
                            iconColor={Colors.red500}
                          />
                        </div>
                      )
                    }

                    return <CellContainer>{content}</CellContainer>
                  },
                },
              ]}
            />
          )}
        </TableContainer>
      </Container>
    )
  }
}

Invoices.propTypes = {
  /** Current student id */
  studentId: PropTypes.number.isRequired,
  /** State of fetching information */
  loading: PropTypes.bool.isRequired,
  /** Array of invoices */
  invoices: PropTypes.object.isRequired,

  /** Get student invoices */
  getInvoices: PropTypes.func.isRequired,
}

const mapStateToProps = ({ classrooms }) => ({
  loading: classrooms.getInvoices.fetching,
  invoices: classrooms.getInvoices.results,
})

const mapDispatchToProps = dispatch => ({
  getInvoices: (studentId, queries = {}) =>
    dispatch(ClassroomActions.getStudentInvoicesRequest(studentId, queries)),
  goTo: path => dispatch(push(path)),
})

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Invoices))



// WEBPACK FOOTER //
// ./src/Components/ProfileViews/Invoices.jsx